import defaultClient from '@src/api/clients/default';

export function fetchZipSubmissions(params = {}) {
  const query = new URLSearchParams(params).toString();
  return defaultClient.request({
    url: `dashboard/zip-submissions/?${query}`,
    method: 'GET',
  });
}

export function fetchZipSubmission(id) {
  return defaultClient.request({
    url: `dashboard/zip-submissions/${id}/`,
    method: 'GET',
  });
}

export function createZipSubmission(payload) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/',
    method: 'POST',
    payload,
  });
}

export function approveZipSubmission(id, payload = {}) {
  return defaultClient.request({
    url: `dashboard/zip-submissions/${id}/approve/`,
    method: 'POST',
    payload,
  });
}

export function rejectZipSubmission(id, payload = {}) {
  return defaultClient.request({
    url: `dashboard/zip-submissions/${id}/reject/`,
    method: 'POST',
    payload,
  });
}

export function cancelZipSubmission(id) {
  return defaultClient.request({
    url: `dashboard/zip-submissions/${id}/cancel/`,
    method: 'POST',
  });
}

export function checkZipOverlap(payload) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/check-overlap/',
    method: 'POST',
    payload,
  });
}

export function pauseTerritory(payload) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/pause-territory/',
    method: 'POST',
    payload,
  });
}

export function exportZipCoverageCsv(clientId) {
  return defaultClient.request({
    url: `dashboard/client-zips/export-csv/?client_id=${clientId}`,
    method: 'GET',
    responseType: 'blob',
  });
}

export function bulkCreateZipSubmissions(payload) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/bulk-create/',
    method: 'POST',
    payload,
  });
}

export function batchApproveZipSubmissions(batchId) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/batch-approve/',
    method: 'POST',
    payload: { batch_id: batchId },
  });
}

export function downloadZipTemplate(clientId) {
  return defaultClient.request({
    url: `dashboard/zip-submissions/download-template/?client_id=${clientId}`,
    method: 'GET',
    responseType: 'blob',
  });
}

export function getZipSubmissionPushReadiness(submissionId) {
  return defaultClient.request({
    url: `dashboard/zip-submissions/${submissionId}/push-readiness/`,
    method: 'GET',
  });
}

export function pushZipSubmissionToFacebook(submissionId, payload = {}) {
  return defaultClient.request({
    url: `dashboard/zip-submissions/${submissionId}/push-to-facebook/`,
    method: 'POST',
    payload,
  });
}
